import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import TablePaginationActions from "../../shared/components/Table/Actions";
import Loading from "../UI/Loading";

export const EMPTY_PAGE = { content: [], number: 0, size: 0, totalElements: 0 };

/** Estrutura comum das listas paginadas da cantina (carregando, vazio e paginação). */
const CantinaPageShared = ({ page, isLoading, loadingText, emptyText, handleChangePage, children }) => {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description={loadingText} />
      </Box>
    );
  }
  if (!page?.content?.length) {
    return (
      <Typography variant="body2" color="text.secondary" textAlign="center" py={6}>
        {emptyText}
      </Typography>
    );
  }
  return (
    <Box>
      {children}
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={page.size || 0}
        component="div"
        count={page.totalElements || 0}
        page={page.number || 0}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
};

export default CantinaPageShared;
